/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../compat/compat-contact-list.component';
const styles_CompatContactListComponent:any[] = ([] as any[]);
export const RenderType_CompatContactListComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CompatContactListComponent,
  data: {}
}
);
export function View_CompatContactListComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_CompatContactListComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-compat-contact-list',([] as any[]),(null as any),(null as any),(null as any),View_CompatContactListComponent_0,RenderType_CompatContactListComponent)),
    import0.ɵdid(49152,(null as any),0,import1.CompatContactListComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CompatContactListComponentNgFactory:import0.ComponentFactory<import1.CompatContactListComponent> = import0.ɵccf('app-compat-contact-list',import1.CompatContactListComponent,View_CompatContactListComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jb250YWN0LWxpc3QuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC1jb250YWN0LWxpc3QuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LWNvbnRhY3QtbGlzdC5jb21wb25lbnQudHMuQ29tcGF0Q29udGFjdExpc3RDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWNvbXBhdC1jb250YWN0LWxpc3Q+PC9hcHAtY29tcGF0LWNvbnRhY3QtbGlzdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/compat/compat-contact-list.component.ngfactory.ts